/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Composables
import { createApp } from 'vue'

// Plugins
import { registerPlugins } from '@/plugins'
import * as Sentry from '@sentry/vue'
import mixpanel from 'mixpanel-browser'

// Components
import App from './App.vue'

const app = createApp(App)

// Initialize Sentry only in production - we typically don't want to track dev env
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: true,
  })
}

// Initialize Mixpanel only in production - we typically don't want to track dev env
if (import.meta.env.VITE_MIXPANEL_TOKEN) {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    debug: false,
    track_pageview: true,
    persistence: 'localStorage'
  })
}

registerPlugins(app)

app.mount('#app')
